import { render } from "./Viewport.vue?vue&type=template&id=6c49c261&scoped=true"
import script from "./Viewport.vue?vue&type=script&lang=js"
export * from "./Viewport.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6c49c261"

export default script